var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReminder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#6E6E6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90002 10.2795L10.823 10.6645C11.3123 9.49883 12.1542 8.51553 13.2305 7.8525L12.708 7C11.4529 7.77357 10.4711 8.92024 9.90002 10.2795ZM21.3615 19.3385V13.9245C21.3597 12.69 20.8975 11.5007 20.0653 10.5889C19.233 9.67717 18.0907 9.10864 16.8615 8.9945V7.9715H15.8615V8.9945C14.6323 9.10853 13.4898 9.67703 12.6576 10.5888C11.8254 11.5006 11.3632 12.69 11.3615 13.9245V19.3385L9 23.4715H13.8615C13.8615 23.7998 13.9262 24.1249 14.0518 24.4282C14.1774 24.7315 14.3616 25.0071 14.5937 25.2393C14.8259 25.4714 15.1015 25.6556 15.4048 25.7812C15.7081 25.9068 16.0332 25.9715 16.3615 25.9715C16.6898 25.9715 17.0149 25.9068 17.3182 25.7812C17.6215 25.6556 17.8971 25.4714 18.1293 25.2393C18.3614 25.0071 18.5456 24.7315 18.6712 24.4282C18.7968 24.1249 18.8615 23.7998 18.8615 23.4715H23.723L21.3615 19.3385ZM16.3615 24.9715C15.9637 24.9715 15.5821 24.8135 15.3008 24.5322C15.0195 24.2509 14.8615 23.8693 14.8615 23.4715H17.8615C17.8615 23.8693 17.7035 24.2509 17.4222 24.5322C17.1409 24.8135 16.7593 24.9715 16.3615 24.9715ZM18.6495 22.4715H10.723L12.3615 19.6045V13.9245C12.3628 12.8764 12.7798 11.8716 13.5209 11.1306C14.2621 10.3895 15.2669 9.97269 16.315 9.9715H16.408C17.4561 9.97269 18.4609 10.3895 19.2021 11.1306C19.9432 11.8716 20.3602 12.8764 20.3615 13.9245V19.6045L22 22.4715H18.6495ZM19.4925 7.8525L20.015 7C21.2705 7.77315 22.2524 8.91995 22.823 10.2795L21.9 10.664C21.4106 9.49855 20.5687 8.51545 19.4925 7.8525Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReminder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reminder.3dc064985ab3f8c285459b47a2fc2f7f.svg";